module.exports = __webpack_public_path__ + "static/media/ConsultButton.1a129150.svg";